export enum Role {
    SUPER_ADMIN = "Nightwatch Admin",
    ADMIN = "Client Admin",
    ADVOCATE = "Advocate"
}